import { StemType } from '@arpeggi/shared'
import { observer } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTreeState } from '../../../stores/Root'

const InstrumentADSR: FC<any> = ({ selectedSample, stem, stemIndex }) => {
  const { studio } = useTreeState()
  const song = studio.song
  const isDrums = stem.type() === StemType.DRUMS
  return (
    <div>
      {!isDrums && (
        <>
          {'AUTO-RELEASE (aka MONOPHONIC)'}
          <div className="d-column-flex ">
            <input
              type="checkbox"
              defaultChecked={selectedSample.autoRelease}
              onChange={() => {
                selectedSample.updateAutoRelease(!selectedSample.autoRelease)
              }}
            />
          </div>
          {/* {'START/END'}
          <div className="d-column-flex ">
            <ValueSlider
              value={selectedSample.start}
              setValue={(e) => {
                song.updateStemSampleStart(e, stemIndex)
              }}
            />
            <ValueSlider
              value={selectedSample.end}
              setValue={(e) => {
                song.updateStemSampleEnd(e, stemIndex)
              }}
            />
          </div>
          <button onClick={(e) => stem.toggleEnvelope()}>
            {' '}
            {selectedSample.adsr ? '-' : '+'}{' '}
          </button>
          {selectedSample.adsr && (
            <>
              {'ADSR'}
              <div className="d-column-flex ">
                <ValueSlider
                  value={selectedSample.adsr.attack}
                  setValue={(e) => {
                    stem.updateAttack(e)
                  }}
                />
                <ValueSlider
                  value={selectedSample.adsr.decay}
                  setValue={(e) => {
                    stem.updateDecay(e)
                  }}
                />
                <ValueSlider
                  value={selectedSample.adsr.sustain}
                  setValue={(e) => {
                    stem.updateSustain(e)
                  }}
                />
                <ValueSlider
                  value={selectedSample.adsr.release}
                  setValue={(e) => {
                    stem.updateRelease(e)
                  }}
                />
              </div>
            </>
          )} */}
        </>
      )}
    </div>
  )
}

export default observer(InstrumentADSR)
